// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"1c0122d7","164":"bbb05166","471":"c6663830","945":"1304075c"}[chunkId] + ".chunk.js";
};